define(['jquery', 'jquery.transit', 'modernizr', 'container'], function ($, transit, modernizr, container) {

    var formValidator = function (id) {

        var publicVars = {
        };

        var privateVars = {
            name: 'formValidator(' + id + ')',
            fields: {
                email: {},
                equal: {},
                int: {},
                notEqual: {},
                required: {}
            }

        };


        var privateMethods = {
            prepareObj: function (options) {

                publicVars = $.extend(true, publicVars, options);

                privateMethods.bind();

            },
            bind: function () {
                container.msg(privateVars.name + ' - module started');
            },
            /*
             * Performs validation and returns overall validation 
             * status and each field validation status
             * 
             * @returns { (Boolean) validFlag, (Object) fieldStatus }
             */
            validate: function () {

                container.msg(privateVars.name + ' - start form validation');

                var validFlag = true;

                for (var i in privateVars.fields['required']) {

                    if (!privateMethods.test.required({
                        value: $(privateVars.fields['required'][i].field).val(),
                        defaultValue: privateVars.fields['required'][i].defaultValue
                    })) {
                        validFlag = false;
                        privateMethods.error.trigger(privateVars.fields['required'][i]);
                    } else {
                        privateMethods.error.clean(privateVars.fields['required'][i]);
                    }

                }

                for (var i in privateVars.fields['email']) {

                    if (!privateMethods.test.email({
                        value: $(privateVars.fields['email'][i].field).val(),
                        defaultValue: privateVars.fields['email'][i].defaultValue,
                        isRequired: privateVars.fields['email'][i].isRequired
                    })) {
                        validFlag = false;
                        privateMethods.error.trigger(privateVars.fields['email'][i]);
                    } else {
                        privateMethods.error.clean(privateVars.fields['email'][i]);
                    }

                }

                for (var i in privateVars.fields['notequal']) {
                    if (!privateMethods.test.notequal({
                        val1: privateVars.fields['notequal'][i].val1,
                        val2: privateVars.fields['notequal'][i].val2
                    })) {
                        validFlag = false;
                        privateMethods.error.trigger(privateVars.fields['notequal'][i]);
                    } else {
                        privateMethods.error.clean(privateVars.fields['notequal'][i]);
                    }
                }



                /*
                 for (var i in privateVars.intTab) {
                 if ($(privateVars.intTab[i].field).val() == '' || isNaN(Number($(privateVars.intTab[i].field).val()))) {
                 privateMethods.triggerError(privateVars.intTab[i].errorField, privateVars.intTab[i].errorClass);
                 validFlag = false;
                 
                 fieldStatus['int'][i] = false;
                 
                 container.msg('form - field error: ' + privateVars.intTab[i].field);
                 } else {
                 
                 fieldStatus['int'][i] = true;
                 
                 privateMethods.cleanError(privateVars.intTab[i].errorField, privateVars.intTab[i].errorClass);
                 }
                 }
                 
                 for (var i in privateVars.emailTab) {
                 if (!privateMethods.testEmailAddress($(privateVars.emailTab[i].field))) {
                 privateMethods.triggerError(privateVars.emailTab[i].errorField, privateVars.emailTab[i].errorClass);
                 validFlag = false;
                 
                 fieldStatus['email'][i] = false;
                 
                 container.msg('form - field error: ' + privateVars.emailTab[i].field);
                 } else {
                 
                 fieldStatus['email'][i] = true;
                 
                 privateMethods.cleanError(privateVars.emailTab[i].errorField, privateVars.emailTab[i].errorClass);
                 }
                 }
                 
                 for (var i in privateVars.equalTab) {
                 if (privateVars.equalTab[i].val1 != privateVars.equalTab[i].val2) {
                 privateMethods.triggerError(privateVars.equalTab[i].errorField, privateVars.equalTab[i].errorClass);
                 validFlag = false;
                 
                 fieldStatus['equal'][i] = false;
                 
                 container.msg('form - field error: ' + privateVars.equalTab[i].field);
                 } else {
                 
                 fieldStatus['equal'][i] = true;
                 
                 privateMethods.cleanError(privateVars.equalTab[i].errorField, privateVars.equalTab[i].errorClass);
                 }
                 }
                 
                 for (var i in privateVars.notEqualTab) {
                 if (privateVars.notEqualTab[i].val1 == privateVars.notEqualTab[i].val2) {
                 privateMethods.triggerError(privateVars.notEqualTab[i].errorField, privateVars.notEqualTab[i].errorClass);
                 validFlag = false;
                 
                 fieldStatus['notequal'][i] = false;
                 
                 container.msg('form - field error: ' + privateVars.notEqualTab[i].field);
                 } else {
                 fieldStatus['notequal'][i] = true;
                 
                 privateMethods.cleanError(privateVars.notEqualTab[i].errorField, privateVars.notEqualTab[i].errorClass);
                 }
                 }
                 */
                if (validFlag) {
                    container.msg(privateVars.name + ' - form is valid!');
                }

                return {validFlag: validFlag, fieldStatus: privateVars.fields};
            },
            /*
             * test email
             * @param String emailToTest 
             */
            testEmailAddress: function (emailToTest) {
                emailToTest = emailToTest.val();

                var newReg = new RegExp('^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$');

                return newReg.test(emailToTest);
            },
            error: {
                /*
                 * trigger error 
                 * @param Object field 
                 * 
                 * {
                 *    errorField: '' // id of error field
                 *    errorClass: '' // class for error field
                 * }
                 * 
                 */
                trigger: function (field) {
                    $(field.errorField).addClass(field.errorClass);

                    field['status'] = false;

                    container.msg(privateVars.name + ' - field error: ' + field.field);
                },
                /*
                 * clean error 
                 * @param Object field 
                 * 
                 * {
                 *    errorField: '' // id of error field
                 *    errorClass: '' // class for error field
                 * }
                 * 
                 */
                clean: function (field) {
                    $(field.errorField).removeClass(field.errorClass);

                    field['status'] = true;
                }
            },
            /*
             * Set fields for validation
             * 
             * @param String type - type of validation fields
             * @param Object obj - object with fields for validation
             */
            set: function (type, obj) {
                privateVars.fields[type] = obj;
            },
            test: {
                /*
                 * 
                 * Check if required field is empty
                 * 
                 * @param Object obj
                 * 
                 * {
                 *      value: '', // input field value
                 *      defaultValue: '' // default value or empty string
                 * }
                 * 
                 * @returns {Boolean}
                 */
                required: function (obj) {
                    if (obj.value == obj.defaultValue || obj.value == '') {
                        return false;
                    } else {
                        return true;
                    }
                },
                /*
                 * Check if value is valid email
                 * 
                 * @param Object obj
                 * 
                 * {
                 *      value: '' // input field value,
                 *      defailtValue: '' // default value or empty string 
                 *      isRequired: {Boolean} // if field is required true or false
                 * }
                 * 
                 * @returns {Boolean}
                 */
                email: function (obj) {


                    if (!obj.isRequired && !privateMethods.test.required({
                        value: obj.value,
                        defaultValue: obj.defaultValue
                    })) {
                        return true;
                    }

                    var newReg = new RegExp(/^.+@.+\..+$/);

                    return newReg.test(obj.value);
                },
                /*
                 * Check if value is not equal value2
                 * 
                 * @param Object obj
                 * 
                 * {
                 *      val1: '' // first value,
                 *      val2: '' // second value, 
                 * }
                 * 
                 * @returns {Boolean}
                 */
                notequal: function (obj) {
                    if(obj.val1 == obj.val2) {
                        return false;
                    } else{
                        return true;
                    }
                }

            },
        };


        var publicObj = {
            init: function (options) {
                privateMethods.prepareObj(options);
            },
            set: privateMethods.set,
            validate: function () {
                return privateMethods.validate();
            }
        }

        return publicObj;
    };

    var factory = {
        objId: 0,
        /**
         * Get new preloader object
         * 
         * @returns preloader
         */
        create: function () {
            factory.objId++;

            var obj = formValidator(factory.objId);

            return obj;
        }
    };

    return {
        create: factory.create
    }

});

/*
 ---
 var formValidator = formValidatorFactory.create();
 ---
 formValidator.set('required', {
 1: {
 field: view.publicVars.cssId.field1requiredId,
 defaultValue: view.publicVars.field1DefaultValue,
 errorField: view.publicVars.cssId.field1requiredId,
 errorClass: view.publicVars.cssId.hasErrorCls.substr(1)
 }
 });
 
 formValidator.set('email', {
 1: {
 field: view.publicVars.cssId.field2emailId,
 defaultValue: '',
 isRequired: true,
 errorField: view.publicVars.cssId.field2emailId,
 errorClass: view.publicVars.cssId.hasErrorCls.substr(1)
 },
 2: {
 field: view.publicVars.cssId.field3emailId,
 defaultValue: '',
 isRequired: false,
 errorField: view.publicVars.cssId.field3emailId,
 errorClass: view.publicVars.cssId.hasErrorCls.substr(1)
 }
 });

 formValidator.set('notequal', {
 1: {
 field: view.publicVars.cssId.field1requiredId,
 errorField: view.publicVars.cssId.field1requiredId,
 errorClass: view.publicVars.cssId.hasErrorCls.substr(1),
 val1: 1,
 val2: 0
 }
 });
 
 formValidator.validate() -> {validFlag: validFlag, fieldStatus: privateVars.fields};
 
 */